"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemSku;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChipStatus = require("../ChipStatus");

var _ImageThumbnail = _interopRequireDefault(require("../ImageThumbnail"));

var _core = require("@material-ui/core");

var _constants = require("../utils/constants");

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      width: "100%"
    },
    imageContainer: {
      padding: "2px"
    },
    skuContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%"
    },
    dateContainer: {
      display: "flex",
      flexDirection: "column",
      fontSize: "smaller"
    },
    id: {
      fontSize: "small",
      color: "dimgrey"
    },
    duplicate: {
      color: "darkgrey",
      fontSize: "smaller"
    },
    pointer: {
      cursor: "pointer"
    }
  };
});
/**
 * List item sebuah SKU menampilkan:
 * - Title sku
 * - sku id
 * - status sku
 * Optional
 * - mergeTitle
 * - mergeId
 * - onClick
 * - image
 * - createdAt
 * - updatedAt
 * @param {Object} param0
 */

function ItemSku(_ref) {
  var title = _ref.title,
      id = _ref.id,
      status = _ref.status,
      mergeId = _ref.mergeId,
      mergeTitle = _ref.mergeTitle,
      onClick = _ref.onClick,
      image = _ref.image,
      createdAt = _ref.createdAt,
      updatedAt = _ref.updatedAt;
  var classes = useStyle();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react["default"].createElement(_ImageThumbnail["default"], {
    src: image,
    alt: title
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.skuContainer, onClick && classes.pointer),
    onClick: onClick && function () {
      return onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, status !== _constants.STATUS_BANNED ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.id
  }, "[", id, "]")) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("strike", {
    className: classes.duplicate
  }, /*#__PURE__*/_react["default"].createElement("div", null, title), /*#__PURE__*/_react["default"].createElement("div", null, "[", id, "]")), mergeId && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, mergeTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.id
  }, "[", mergeId, "]"))), (createdAt || updatedAt) && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.dateContainer
  }, /*#__PURE__*/_react["default"].createElement("div", null, "created:", " ", createdAt ? new Date(createdAt).toLocaleString() : "-"), /*#__PURE__*/_react["default"].createElement("div", null, "updated:", " ", updatedAt ? new Date(updatedAt).toLocaleString() : "-"))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatus, {
    code: status
  }))));
}

ItemSku.propTypes = {
  id: _propTypes["default"].string,
  status: _propTypes["default"].number,
  title: _propTypes["default"].string,
  mergeId: _propTypes["default"].string,
  mergeTitle: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  image: _propTypes["default"].string,
  createdAt: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string]),
  updatedAt: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string])
};